<template>
  <div>
    <Nav ></Nav>
<!--    <keep-alive>-->
      <router-view v-if="RouterShow"></router-view>
<!--    </keep-alive>-->
  </div>
</template>

<script>
import Nav from "./nav";
import {myMixin} from '@/mixins/tool.js'

export default {
  name: "mobile",
  components: {Nav},
  mixins: [myMixin]
};
</script>
<style lang="less">
@import "~@/assets/todoCenter/default/css/wechat.less";
</style>




// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/index.vue